import type { IconToken } from '../common/icon/directives/icon-color.directive';
import type { IconName } from '../common/icon/icons.type';

export type NestedIcon = { [key: string]: IconName } & { default: IconName };
export const keyIconMap = <T extends Record<string, IconName | NestedIcon>>(v: T): T => v;
export const keyIconTokenMap = <T extends Record<string, IconToken>>(v: T): T => v;
